import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

type listStageType = {
    number: number;
    text: string;
};
type LayoutPagePropsType = {
    listStages: listStageType[];
};
const LayoutPage = ({ listStages }: LayoutPagePropsType) => {
    return (
        <div className="rgs-layout-page">
            <FullWrapper className="rgs-layout-pageCase" isMargin={false}>
                <div className="rgs-layout-pageWrapper">
                    <div className="rgs-layout-pageBottom">Цели и&nbsp;задачи проекта</div>
                    <div className="rgs-layout-pageOneParagraf">
                        Основная цель проекта заключалась в&nbsp;создании эффективной системы
                        автоматизации продаж и&nbsp;оформления договоров КАСКО и&nbsp;ОСАГО
                        за&nbsp;счет омниканального фронт-решения.
                    </div>
                    <div className="rgs-layout-pageSubtitle">Новая система должна обеспечить:</div>
                    {listStages.map(({ text, number }, index) => (
                        <div key={index} className="rgs-layout-pageList">
                            <div className="rgs-layout-pageListNumber">{number}</div>
                            <div
                                dangerouslySetInnerHTML={{ __html: text }}
                                className="rgs-layout-pageListText"
                            />
                        </div>
                    ))}
                </div>
            </FullWrapper>
        </div>
    );
};

export default LayoutPage;
